import React, { useEffect } from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { useItem, useItemRelistSeller } from '@/hooks/item';
import { ItemRelistSellerModal } from '@/types/modal';
import { CopyModal, ErrorModal, LoadingBodyModal, StandardModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: ItemRelistSellerModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;

  const itemR = useItem(item.productId, false);
  const submitR = useItemRelistSeller(item.productId);

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      itemR.refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.item_relist_seller.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <CopyModal
        title={t('modal.item_relist_seller.title_success')}
        beforeInfo={
          <>
            <div className={styles.paddingY1rem}>{t('modal.item_relist_seller.new_item_created')}</div>
            <div className={styles.height05rem} />
            <div className={clsx([styles.text075rem, styles.textGrey])}>
              {t('modal.item_relist_seller.new_item_reference')}
            </div>
            <div className={styles.height05rem} />
          </>
        }
        afterInfo={<br />}
        textToCopy={String(submitR.data.newProductId)}
        onClose={onClose}
      />
    );
  }

  const body =
    submitR.kind === 'Loading' ? (
      <LoadingBodyModal height={40} />
    ) : (
      <div className={clsx([styles.text1rem, styles.paddingY1rem])}>{t('modal.item_relist_seller.body')}</div>
    );

  return (
    <StandardModal
      title={t('modal.item_relist_seller.title')}
      onClose={onClose}
      onSubmit={() =>
        submitR.mutate({
          clientId: Number(item.sellerId),
          relistType: 'seller',
        })
      }
      submitLabel={t('common.submit').toUpperCase()}
      submittable={submitR.kind !== 'Loading'}
      body={body}
      containerStyle={{ width: 400 }}
      modalName="item_relist_seller"
    />
  );
};

export default View;
